import { Link } from 'react-router-dom';

export default function ArticleHub() {
  return (
    <section className="py-24 md:py-32 px-4 bg-background-50">
      <div className="max-w-3xl mx-auto text-center">
        <p className="font-label text-xs tracking-[0.2em] uppercase text-foreground-400 mb-6">
          Editor&rsquo;s Pick
        </p>

        <div className="font-body text-foreground-700 leading-relaxed text-base md:text-lg space-y-5">
          <p>
            Navigating the world of <strong className="text-foreground-950">CSSBuy spreadsheet</strong> resources can feel overwhelming — hundreds of links,
            countless categories, and the constant question of which finds are actually worth your money. That&rsquo;s exactly why we built this hub.
          </p>
          <p>
            Our <strong className="text-foreground-950">curated CSSBuy spreadsheet</strong> collection brings together the most verified fashion items across
            shoes, clothing, accessories, and lifestyle products. Every link is checked for quality, every category is organized for easy browsing, and every
            recommendation is backed by real community feedback — not automated scraping.
          </p>
          <p>
            Whether you&rsquo;re hunting for the latest <strong className="text-foreground-950">sneaker drops</strong>, building a <strong className="text-foreground-950">winter wardrobe</strong> on a budget,
            or exploring <strong className="text-foreground-950">premium designer finds</strong> through agents like CSSBuy, Kakobuy, Superbuy, and Oopbuy — our
            spreadsheet resources give you the confidence to shop smarter. We update daily so you never miss a trending find or a verified seller deal.
          </p>
          <p>
            Ready to level up your shopping game? Dive into our complete guide below and discover why thousands of savvy shoppers trust the CSS Spreadsheet hub
            as their go-to resource for fashion discovery. &#x263A;
          </p>
        </div>

        <Link
          to="/cssbuy-spreadsheet-guide"
          className="inline-block mt-10 px-8 py-3.5 bg-foreground-950 text-background-50 font-label font-medium text-sm rounded-full hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          Read CSSBuy Guide &rarr;
        </Link>
      </div>
    </section>
  );
}